import { useRef } from 'react'
import  { ExclamationCircleIcon, ExclamationIcon } from '@heroicons/react/outline'

import GenericModal from './genericModal';

const errorTypes = {
  error: "error",
  warn:"warn",
}

function GenericErrorModal({open, setOpen, titel, contentJsx, type = errorTypes.error, useIcon = true}) {
  const cancelButtonRef = useRef(null);

  const handleOnSubmit = () => {
    setOpen(false);
  }

  const getIcon = (type) => {
    switch (type) {
      case errorTypes.error:
        return <ExclamationCircleIcon className="h-5 w-5 my-auto" aria-hidden="true" />;
      case errorTypes.warn:
        return <ExclamationIcon className="h-5 w-5 my-auto" aria-hidden="true" />;
      default:
        return <></>;
    }
  }

  return (
    <GenericModal open={open} setOpen={setOpen}
      onConfirm={handleOnSubmit}
      onCancel={() => setOpen(false)}
      showCancelButton={false}
      confirmButtonText={'Close'}
      title={titel}>
        <div className="mt-4 text-sm text-gray-700 dark:text-gray-300">
          {contentJsx}
        </div>
    </GenericModal>
   )
}

GenericErrorModal.types = errorTypes;

export { GenericErrorModal }